import React, { useState, useEffect, useMemo } from 'react';
import { getInfoTables } from '../getInfoTables';
import {
  Box,
  Card,
  CardHeader,
  Divider
} from '@mui/material';
import Table from '../../../Table';
import { timeOfFinishAttendanceHeader, timeOfInitAttendanceHeader } from './components';


const OcorrenciasPorBairros = ({ occurrences }) => {

  const [infoNeighborhoods, setInfoNeighborhoods] = useState([]);

  useEffect(() => {
    update()
  }, [occurrences]); // eslint-disable-line react-hooks/exhaustive-deps

  async function update() {
    const neighborhoods = await getInfoTables({
      occurrences,
      nameObject: "area",
      route: "areas"
    });

    setInfoNeighborhoods(neighborhoods);
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Tipo',
        accessor: 'name',
      },
      {
        Header: 'Ocorrências Novas',
        accessor: 'Novo',
      },
      {
        Header: 'Ocorrências Em análise',
        accessor: 'Em análise'
      },
      {
        Header: 'Ocorrências Resolvidas',
        accessor: 'Resolvido'
      },
      {
        Header: 'Ocorrências Indeferidas',
        accessor: 'Indeferido'
      },
      {
        Header: timeOfInitAttendanceHeader(),
        accessor: 'totalServiceTime'
      },

      {
        Header: timeOfFinishAttendanceHeader(),
        accessor: 'totalTimeToResponse'
      }
    ], []
  )

  return (
    <Card>
      <CardHeader
        className="box-title"
        title="Ocorrências por Tipos"
      />
      <Divider />
      <Table columns={columns} data={infoNeighborhoods} fixedPageSize={4} hideSearch={true} />

      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
      </Box>
    </Card>
  );


}

export default OcorrenciasPorBairros;
